import React, { useState, useEffect } from 'react';
import initSqlJs from 'sql.js';
import { useParams } from 'react-router-dom';
import AceEditor from "react-ace";
import "ace-builds/src-noconflict/theme-github";


import "ace-builds/src-noconflict/mode-sql";
import "ace-builds/src-noconflict/theme-monokai";
import { format as formatSQL } from 'sql-formatter'; // Importing the format function


import './sqltutorial.css';

function SqlTutorial() {
  const [db, setDb] = useState(null);
  const [query, setQuery] = useState('');
const [results, setResults] = useState({ columns: [], rows: [] });
  const [error, setError] = useState('');
  const params = useParams();

  useEffect(() => {
    initSqlJs().then(SQL => {
      const db = new SQL.Database();

db.run("CREATE TABLE sellers (seller_id INTEGER PRIMARY KEY, seller_name TEXT, industry TEXT, location TEXT)");
db.run("CREATE TABLE orders (order_id INTEGER PRIMARY KEY, seller_id INTEGER, customer_name TEXT, order_date TEXT, amount REAL, status TEXT, FOREIGN KEY (seller_id) REFERENCES sellers(seller_id))");


db.run(`INSERT INTO orders (order_id, seller_id, customer_name, order_date, amount, status) VALUES
(1, 43, 'Customer 1', '2023-07-03', 915.81, 'Pending'),
(2, 1, 'Customer 2', '2023-06-18', 466.74, 'Delivered'),
(3, 6, 'Customer 3', '2023-09-17', 698.2, 'Pending'),
(4, 15, 'Customer 4', '2023-10-09', 642.1, 'Shipped'),
(5, 19, 'Customer 5', '2023-02-22', 706.73, 'Pending'),
(6, 46, 'Customer 6', '2023-01-30', 176.86, 'Pending'),
(7, 29, 'Customer 7', '2023-06-28', 157.13, 'Pending'),
(8, 39, 'Customer 8', '2023-12-21', 481.29, 'Delivered'),
(9, 24, 'Customer 9', '2023-02-15', 316.48, 'Delivered'),
(10, 47, 'Customer 10', '2023-10-31', 167.16, 'Delivered'),
(11, 41, 'Customer 11', '2023-02-02', 518.58, 'Shipped'),
(12, 13, 'Customer 12', '2023-07-31', 156.67, 'Shipped'),
(13, 19, 'Customer 13', '2023-01-29', 416.3, 'Pending'),
(14, 12, 'Customer 14', '2023-08-13', 769.34, 'Shipped'),
(15, 40, 'Customer 15', '2023-06-29', 613.07, 'Shipped'),
(16, 35, 'Customer 16', '2023-12-24', 410.14, 'Delivered'),
(17, 48, 'Customer 17', '2023-01-18', 426.21, 'Pending'),
(18, 2, 'Customer 18', '2023-10-24', 341.71, 'Delivered'),
(19, 50, 'Customer 19', '2023-05-12', 628.3, 'Delivered'),
(20, 35, 'Customer 20', '2023-02-26', 594.07, 'Delivered'),
(21, 27, 'Customer 21', '2023-02-26', 765.82, 'Delivered'),
(22, 30, 'Customer 22', '2023-08-31', 669.68, 'Shipped'),
(23, 12, 'Customer 23', '2023-04-28', 512.05, 'Shipped'),
(24, 43, 'Customer 24', '2023-11-28', 758.84, 'Pending'),
(25, 45, 'Customer 25', '2023-05-02', 979.82, 'Shipped'),
(26, 13, 'Customer 26', '2023-04-29', 136.21, 'Pending'),
(27, 1, 'Customer 27', '2023-08-28', 717.53, 'Shipped'),
(28, 44, 'Customer 28', '2023-12-06', 345.43, 'Pending'),
(29, 9, 'Customer 29', '2023-07-12', 887.72, 'Pending'),
(30, 11, 'Customer 30', '2023-04-05', 777.82, 'Shipped'),
(31, 18, 'Customer 31', '2023-04-23', 410.42, 'Shipped'),
(32, 38, 'Customer 32', '2023-04-21', 441.0, 'Pending'),
(33, 25, 'Customer 33', '2023-01-18', 608.33, 'Delivered'),
(34, 2, 'Customer 34', '2023-05-30', 736.15, 'Shipped'),
(35, 44, 'Customer 35', '2023-05-27', 808.14, 'Shipped'),
(36, 35, 'Customer 36', '2023-04-30', 905.02, 'Shipped'),
(37, 20, 'Customer 37', '2023-10-24', 898.44, 'Delivered'),
(38, 40, 'Customer 38', '2023-04-19', 881.57, 'Shipped'),
(39, 32, 'Customer 39', '2023-10-10', 223.17, 'Pending'),
(40, 40, 'Customer 40', '2023-10-30', 204.73, 'Pending'),
(41, 33, 'Customer 41', '2023-02-18', 664.62, 'Shipped'),
(42, 46, 'Customer 42', '2023-11-08', 821.35, 'Shipped'),
(43, 42, 'Customer 43', '2023-03-19', 408.27, 'Delivered'),
(44, 6, 'Customer 44', '2023-02-06', 320.21, 'Delivered'),
(45, 1, 'Customer 45', '2023-05-24', 742.38, 'Shipped'),
(46, 11, 'Customer 46', '2023-06-20', 391.6, 'Shipped'),
(47, 31, 'Customer 47', '2023-05-20', 685.91, 'Pending'),
(48, 8, 'Customer 48', '2023-05-02', 777.88, 'Shipped'),
(49, 7, 'Customer 49', '2023-12-01', 349.63, 'Delivered'),
(50, 11, 'Customer 50', '2023-12-30', 741.3, 'Delivered')`);
      

db.run(`INSERT INTO sellers (seller_id, seller_name, industry, location) VALUES
(1, 'Seller 1', 'Automotive', 'Chicago'),
(2, 'Seller 2', 'Automotive', 'San Francisco'),
(3, 'Seller 3', 'Technology', 'Chicago'),
(4, 'Seller 4', 'Retail', 'Los Angeles'),
(5, 'Seller 5', 'Education', 'Chicago'),
(6, 'Seller 6', 'Retail', 'Chicago'),
(7, 'Seller 7', 'Healthcare', 'Chicago'),
(8, 'Seller 8', 'Technology', 'Chicago'),
(9, 'Seller 9', 'Healthcare', 'Chicago'),
(10, 'Seller 10', 'Retail', 'Los Angeles'),
(11, 'Seller 11', 'Retail', 'New York'),
(12, 'Seller 12', 'Automotive', 'Boston'),
(13, 'Seller 13', 'Healthcare', 'Boston'),
(14, 'Seller 14', 'Automotive', 'San Francisco'),
(15, 'Seller 15', 'Healthcare', 'Los Angeles'),
(16, 'Seller 16', 'Technology', 'Chicago'),
(17, 'Seller 17', 'Technology', 'Chicago'),
(18, 'Seller 18', 'Education', 'San Francisco'),
(19, 'Seller 19', 'Technology', 'Boston'),
(20, 'Seller 20', 'Education', 'Los Angeles'),
(21, 'Seller 21', 'Technology', 'New York'),
(22, 'Seller 22', 'Automotive', 'Los Angeles'),
(23, 'Seller 23', 'Technology', 'Los Angeles'),
(24, 'Seller 24', 'Technology', 'San Francisco'),
(25, 'Seller 25', 'Automotive', 'Los Angeles'),
(26, 'Seller 26', 'Education', 'Boston'),
(27, 'Seller 27', 'Healthcare', 'Chicago'),
(28, 'Seller 28', 'Healthcare', 'Los Angeles'),
(29, 'Seller 29', 'Retail', 'Boston'),
(30, 'Seller 30', 'Retail', 'Los Angeles'),
(31, 'Seller 31', 'Automotive', 'Los Angeles'),
(32, 'Seller 32', 'Automotive', 'New York'),
(33, 'Seller 33', 'Retail', 'Chicago'),
(34, 'Seller 34', 'Healthcare', 'New York'),
(35, 'Seller 35', 'Automotive', 'Los Angeles'),
(36, 'Seller 36', 'Healthcare', 'Chicago'),
(37, 'Seller 37', 'Automotive', 'New York'),
(38, 'Seller 38', 'Healthcare', 'Los Angeles'),
(39, 'Seller 39', 'Automotive', 'Chicago'),
(40, 'Seller 40', 'Technology', 'Boston'),
(41, 'Seller 41', 'Healthcare', 'Chicago'),
(42, 'Seller 42', 'Retail', 'Chicago'),
(43, 'Seller 43', 'Retail', 'Boston'),
(44, 'Seller 44', 'Technology', 'San Francisco'),
(45, 'Seller 45', 'Healthcare', 'Los Angeles'),
(46, 'Seller 46', 'Automotive', 'Boston'),
(47, 'Seller 47', 'Education', 'Los Angeles'),
(48, 'Seller 48', 'Healthcare', 'Los Angeles'),
(49, 'Seller 49', 'Healthcare', 'Chicago'),
(50, 'Seller 50', 'Retail', 'Boston')`);


      setDb(db);
    });

    if (params.queryParam) {
      setQuery(formatSQL(decodeURIComponent(params.queryParam)));

    }
  }, [params.queryParam]);

const executeQuery = () => {
  try {
    const res = db.exec(query);
    const columnNames = res[0] ? res[0].columns : [];
    const rows = res[0] ? res[0].values : [];
    setResults({ columns: columnNames, rows: rows });
    setError('');
  } catch (err) {
    setResults({ columns: [], rows: [] });
    setError('Error in SQL: ' + err.message);
  }
};

  return (
<div className="app-container">
    <h1>SQL Query Executor</h1>
<h3 class="subtle-section">Edit the query and run it yourself! You have access to both the orders and sellers tables.</h3>
    <div className="query-input">
      <AceEditor
        mode="sql"
        theme="github" // Changed theme to 'github' for a white background
        name="queryEditor"
        value={query}
        onChange={setQuery}
        fontSize={14}
        showPrintMargin={true}
        wrapEnabled={true}
        showGutter={true}
        highlightActiveLine={true}
        setOptions={{
          enableBasicAutocompletion: false,
          enableLiveAutocompletion: false,
          enableSnippets: false,
          showLineNumbers: true,
          tabSize: 2,
        }}
        style={{ width: '100%', minHeight: '50px', maxHeight: "150px" }} // Adjusted minHeight for a shorter editor
      />
      <button onClick={executeQuery} style={{ marginTop: '10px' }}>Run Query</button> {/* Added margin to the top of the button */}
    </div>
    <div className="results-container">
  {error ? (
    <div className="error-message">{error}</div>
  ) : (
    <table className="results-table">
      <thead>
        <tr>
          {results.columns.map((colName, index) => (
            <th key={index}>{colName}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {results.rows.map((row, i) => (
          <tr key={i}>
            {row.map((col, j) => <td key={j}>{col}</td>)}
          </tr>
        ))}
      </tbody>
    </table>
  )}
</div>
    </div>
  );
}

export default SqlTutorial;